import UserActionTypes from './user-types'

export const changeUserStatus = data => ({
    type: UserActionTypes.CHANGE_USER_STATUS,
    payload: data,
})

export const pushAccountPage = data => ({
    type: UserActionTypes.PUSH_ACCOUNT_PAGE,
    payload: data,
})

export const signUpStart = userCredentials => ({
    type: UserActionTypes.SIGN_UP_START,
    payload: userCredentials,
})

export const signUpFailure = data => ({
    type: UserActionTypes.SIGN_UP_FAILURE,
    payload: data,
})

export const authenticateUserStart = data => ({
    type: UserActionTypes.AUTHENTICATE_USER,
    payload: data,
})

export const signInStart = userCredentials => ({
    type: UserActionTypes.SIGN_IN_START,
    payload: userCredentials,
})

export const signInAuthStart = data => ({
    type: UserActionTypes.SIGN_IN_AUTH_START,
    payload: data,
})

export const signIn2FAStart = data => ({
    type: UserActionTypes.SIGN_IN_2FA_START,
    payload: data,
})

export const signInSuccess = data => ({
    type: UserActionTypes.SIGN_IN_SUCCESS,
    payload: data,
})

export const signInFinish = data => ({
    type: UserActionTypes.SIGN_IN_FINISH,
    payload: data,
})

export const signInFailure = data => ({
    type: UserActionTypes.SIGN_IN_FAILURE,
    payload: data,
})

export const signInAttemptExpired = data => ({
    type: UserActionTypes.SIGN_IN_ATTEMPT_EXPIRED,
    payload: data,
})

export const checkUserSession = data => ({
    type: UserActionTypes.CHECK_USER_SESSION,
    payload: data,
})

export const startChangeLanguage = data => ({
    type: UserActionTypes.START_CHANGE_LANGUAGE,
    payload: data,
})

export const successChangeLanguage = data => ({
    type: UserActionTypes.SUCCESS_CHANGE_LANGUAGE,
    payload: data,
})

export const failureChangeLanguage = data => ({
    type: UserActionTypes.FAILURE_CHANGE_LANGUAGE,
    payload: data,
})

export const logout = data => ({
    type: UserActionTypes.LOGOUT_START,
    payload: data,
})

export const successLogout = data => ({
    type: UserActionTypes.LOGOUT_SUCCESS,
    payload: data,
})
export const failureLogout = data => ({
    type: UserActionTypes.LOGOUT_FAILURE,
    payload: data,
})

export const onFailure = data => ({
    type: UserActionTypes.ON_FAILURE,
    payload: data,
})

export const startSwitchUserAccount = data => ({
    type: UserActionTypes.START_SWITCH_USER_ACCOUNT,
    payload: data,
})

export const successSwitchUserAccount = data => ({
    type: UserActionTypes.SUCCESS_SWITCH_USER_ACCOUNT,
    payload: data,
})

export const finishSwitchUserAccount = data => ({
    type: UserActionTypes.FINISH_SWITCH_USER_ACCOUNT,
    payload: data,
})

export const failureSwitchUserAccount = data => ({
    type: UserActionTypes.FAILURE_SWITCH_USER_ACCOUNT,
    payload: data,
})

export const startSwitchOnboardingIntent = data => ({
    type: UserActionTypes.START_SWITCH_ONBOARDING_INTENT,
    payload: data,
})

export const successSwitchOnboardingIntent = data => ({
    type: UserActionTypes.SUCCESS_SWITCH_ONBOARDING_INTENT,
    payload: data,
})

export const finishSwitchOnboardingIntent = data => ({
    type: UserActionTypes.FINISH_SWITCH_ONBOARDING_INTENT,
    payload: data,
})

export const failureSwitchOnboardingIntent = data => ({
    type: UserActionTypes.FAILURE_SWITCH_ONBOARDING_INTENT,
    payload: data,
})

export const startFetchUserAccounts = data => ({
    type: UserActionTypes.START_FETCH_USER_ACCOUNTS,
    payload: data,
})

export const successFetchUserAccounts = data => ({
    type: UserActionTypes.SUCCESS_FETCH_USER_ACCOUNTS,
    payload: data,
})

/*****************   Fetch user service plan  *******************/

export const startFetchCurrentServicePlan = data => ({
    type: UserActionTypes.START_FETCH_ACTIVE_SERVICE_PLAN,
    payload: data,
})
export const successFetchCurrentServicePlan = data => ({
    type: UserActionTypes.SUCCESS_FETCH_ACTIVE_SERVICE_PLAN,
    payload: data,
})

/*****************    Fetch user addresses  *******************/

export const fetchUserAddresses = data => ({
    type: UserActionTypes.FETCH_USER_ADDRESSES,
    payload: data,
})

export const successUserAddresses = data => ({
    type: UserActionTypes.SUCCESS_USER_ADDRESSES,
    payload: data,
})

export const finishUserAddresses = data => ({
    type: UserActionTypes.FINISH_USER_ADDRESSES,
    payload: data,
})

export const failureUserAddresses = data => ({
    type: UserActionTypes.FAILURE_USER_ADDRESSES,
    payload: data,
})

/*****************    Onboarding fee   *******************/

export const fetchOnboardingFees = data => ({
    type: UserActionTypes.FETCH_ONBOARDING_FEE,
    payload: data,
})

export const successOnboardingFees = data => ({
    type: UserActionTypes.SUCCESS_ONBOARDING_FEE,
    payload: data,
})

export const failureOnboardingFees = data => ({
    type: UserActionTypes.FAILURE_ONBOARDING_FEE,
    payload: data,
})

/*****************    Fetch ip data   *******************/

export const startFetchIpData = data => ({
    type: UserActionTypes.START_FETCH_IP_DATA,
    payload: data,
})

export const successFetchIpData = data => ({
    type: UserActionTypes.SUCCESS_FETCH_IP_DATA,
    payload: data,
})

export const failureFetchIpData = data => ({
    type: UserActionTypes.FAILURE_FETCH_IP_DATA,
    payload: data,
})

/*****************    Resend email confirmation to user   *******************/

export const startResendConfirmEmail = data => ({
    type: UserActionTypes.START_RESEND_CONFIRM_EMAIL,
    payload: data,
})

export const successResendConfirmEmail = data => ({
    type: UserActionTypes.SUCCESS_RESEND_CONFIRM_EMAIL,
    payload: data,
})

export const failureResendConfirmEmail = data => ({
    type: UserActionTypes.FAILURE_RESEND_CONFIRM_EMAIL,
    payload: data,
})

export const finishResendConfirmEmail = data => ({
    type: UserActionTypes.FINISH_RESEND_CONFIRM_EMAIL,
    payload: data,
})

/*****************    Fetch sumsub access token    *******************/

export const startFetchSsAccessToken = data => ({
    type: UserActionTypes.START_FETCH_SS_ACCESS_TOKEN,
    payload: data,
})

export const successFetchSsAccessToken = data => ({
    type: UserActionTypes.SUCCESS_FETCH_SS_ACCESS_TOKEN,
    payload: data,
})

export const failureFetchSsAccessToken = data => ({
    type: UserActionTypes.FAILURE_FETCH_SS_ACCESS_TOKEN,
    payload: data,
})

//**************************  Complete verification ***************************/

export const startCompleteUserSsAccessVerification = data => ({
    type: UserActionTypes.START_COMPLETE_USER_SS_ACCESS_VERIFICATION,
    payload: data,
})

export const successCompleteUserSsAccessVerification = data => ({
    type: UserActionTypes.SUCCESS_COMPLETE_USER_SS_ACCESS_VERIFICATION,
    payload: data,
})

export const failureCompleteUserSsAccessVerification = data => ({
    type: UserActionTypes.FAILURE_COMPLETE_USER_SS_ACCESS_VERIFICATION,
    payload: data,
})

/*************************  Password reset request ************************** */

export const startPasswordResetRequest = data => ({
    type: UserActionTypes.START_PASSWORD_RESET_REQUEST,
    payload: data,
})

export const successPasswordResetRequest = data => ({
    type: UserActionTypes.SUCCESS_PASSWORD_RESET_REQUEST,
    payload: data,
})

export const finishPasswordResetRequest = data => ({
    type: UserActionTypes.FINISH_PASSWORD_RESET_REQUEST,
    payload: data,
})

export const failurePasswordResetRequest = data => ({
    type: UserActionTypes.FAILURE_PASSWORD_RESET_REQUEST,
    payload: data,
})

/**********************  Temprary password change  on password reset  ***********************/

export const startTemporaryPasswordChange = data => ({
    type: UserActionTypes.START_TEMPORARY_PASSWORD_CHANGE,
    payload: data,
})

export const successTemporaryPasswordChange = data => ({
    type: UserActionTypes.SUCCESS_TEMPORARY_PASSWORD_CHANGE,
    payload: data,
})

export const finishTemporaryPasswordChange = data => ({
    type: UserActionTypes.FINISH_TEMPORARY_PASSWORD_CHANGE,
    payload: data,
})

export const failureTemporaryPasswordChange = data => ({
    type: UserActionTypes.FAILURE_TEMPORARY_PASSWORD_CHANGE,
    payload: data,
})

/*************************  Fetch latest transactions ************************** */

export const startFetchLatestSessions = data => ({
    type: UserActionTypes.START_FETCH_LATEST_SESSIONS,
    payload: data,
})

export const successFetchLatestSessions = data => ({
    type: UserActionTypes.SUCCESS_FETCH_LATEST_SESSIONS,
    payload: data,
})

export const finishFetchLatestSessions = data => ({
    type: UserActionTypes.FINISH_FETCH_LATEST_SESSIONS,
    payload: data,
})

export const failureFetchLatestSessions = data => ({
    type: UserActionTypes.FAILURE_FETCH_LATEST_SESSIONS,
    payload: data,
})

/*************************  Fetch latest transactions ************************** */

export const startRefreshToken = data => ({
    type: UserActionTypes.START_REFRESH_TOKEN,
    payload: data,
})

export const successRefreshToken = data => ({
    type: UserActionTypes.SUCCESS_REFRESH_TOKEN,
    payload: data,
})

export const finishRefreshToken = data => ({
    type: UserActionTypes.FINISH_REFRESH_TOKEN,
    payload: data,
})

export const failureRefreshToken = data => ({
    type: UserActionTypes.FAILURE_REFRESH_TOKEN,
    payload: data,
})

/*************************  Check user email confirmed ************************** */

export const startCheckUserEmailStatus = data => ({
    type: UserActionTypes.START_CHECK_USER_EMAIL_STATUS,
    payload: data,
})

export const successCheckUserEmailStatus = data => ({
    type: UserActionTypes.SUCCESS_CHECK_USER_EMAIL_STATUS,
    payload: data,
})

/*************************  Confirm user email ************************** */

export const startConfirmUserEmail = data => ({
    type: UserActionTypes.START_CONFIRM_USER_EMAIL,
    payload: data,
})

export const successConfirmUserEmail = data => ({
    type: UserActionTypes.SUCCESS_CONFIRM_USER_EMAIL,
    payload: data,
})

export const finishConfirmUserEmail = data => ({
    type: UserActionTypes.FINISH_CONFIRM_USER_EMAIL,
    payload: data,
})

export const failureConfirmUserEmail = data => ({
    type: UserActionTypes.FAILURE_CONFIRM_USER_EMAIL,
    payload: data,
})

/*************************  Fetch user permissions ************************** */

export const startUserAccountPermissions = data => ({
    type: UserActionTypes.START_USER_ACCOUNTS_PERMISSIONS,
    payload: data,
})

export const successUserAccountPermissions = data => ({
    type: UserActionTypes.SUCCESS_USER_ACCOUNTS_PERMISSIONS,
    payload: data,
})

export const finishUserAccountPermissions = data => ({
    type: UserActionTypes.SUCCESS_USER_ACCOUNTS_PERMISSIONS,
    payload: data,
})

/*************************  Start Playground mode ************************** */

export const startPlaygroundMode = data => ({
    type: UserActionTypes.START_PLAYGROUND_MODE,
    payload: data,
})

export const successPlaygroundMode = data => ({
    type: UserActionTypes.SUCCESS_PLAYGROUND_MODE,
    payload: data,
})

export const finishPlaygroundMode = data => ({
    type: UserActionTypes.FINISH_PLAYGROUND_MODE,
    payload: data,
})

export const failurePlaygroundMode = data => ({
    type: UserActionTypes.FAILURE_PLAYGROUND_MODE,
    payload: data,
})

/*************************  Start External Account Linking ************************** */

export const startExternalAccountLink = data => ({
    type: UserActionTypes.START_EXTERNAL_ACCOUNT_LINK,
    payload: data,
})

export const successExternalAccountLink = data => ({
    type: UserActionTypes.SUCCESS_EXTERNAL_ACCOUNT_LINK,
    payload: data,
})

export const finishExternalAccountLink = data => ({
    type: UserActionTypes.FINISH_EXTERNAL_ACCOUNT_LINK,
    payload: data,
})

export const failureExternalAccountLink = data => ({
    type: UserActionTypes.FAILURE_EXTERNAL_ACCOUNT_LINK,
    payload: data,
})

/*************************  Fetch defaultTwoFactorAuthenticationType ************************** */

export const fetchDefaultTwoFactorAuthenticationType = data => ({
    type: UserActionTypes.FETCH_DEFAULT_2FA_TYPE,
    payload: data,
})

export const successDefaultTwoFactorAuthenticationType = data => ({
    type: UserActionTypes.SUCCESS_DEFAULT_2FA_TYPE,
    payload: data,
})

/*************************  Fetch User Phone Confirmation ************************** */

export const getUserPhoneConfirmation = data => ({
    type: UserActionTypes.GET_USER_PHONE_CONFIRMATION,
    payload: data,
})

export const successUserPhoneConfirmation = data => ({
    type: UserActionTypes.SUCCESS_USER_PHONE_CONFIRMATION,
    payload: data,
})

/****************** Business Registration on Sign UP *******************/
export const startBusinessRegistrationSignUp = data => ({
    type: UserActionTypes.START_BUSINESS_REGISTRATION_SIGN_UP,
    payload: data,
})

export const successBusinessRegistrationSignUp = data => ({
    type: UserActionTypes.SUCCESS_BUSINESS_REGISTRATION_SIGN_UP,
    payload: data,
})

export const failureBusinessRegistrationSignUp = data => ({
    type: UserActionTypes.FAILURE_BUSINESS_REGISTRATION_SIGN_UP,
    payload: data,
})

/*************************  Start Put Personal Questionnaire ************************** */

export const startPutPersonalQuestionnaire = data => ({
    type: UserActionTypes.START_PUT_PERSONAL_QUESTIONNAIRE,
    payload: data,
})

export const successPutPersonalQuestionnaire = data => ({
    type: UserActionTypes.SUCCESS_PUT_PERSONAL_QUESTIONNAIRE,
    payload: data,
})

export const finishPutPersonalQuestionnaire = data => ({
    type: UserActionTypes.FINISH_PUT_PERSONAL_QUESTIONNAIRE,
    payload: data,
})

export const failurePutPersonalQuestionnaire = data => ({
    type: UserActionTypes.FAILURE_PUT_PERSONAL_QUESTIONNAIRE,
    payload: data,
})

/*************************  Start Get Campanies Registration Fee  ************************** */

export const startGetCompaniesRegistrationFee = data => ({
    type: UserActionTypes.START_GET_COMPANIES_REGISTRATION_FEE,
    payload: data,
})

export const successGetCompaniesRegistrationFee = data => ({
    type: UserActionTypes.SUCCESS_GET_COMPANIES_REGISTRATION_FEE,
    payload: data,
})

export const finishGetCompaniesRegistrationFee = data => ({
    type: UserActionTypes.FINISH_GET_COMPANIES_REGISTRATION_FEE,
    payload: data,
})

export const failureGetCompaniesRegistrationFee = data => ({
    type: UserActionTypes.FAILURE_GET_COMPANIES_REGISTRATION_FEE,
    payload: data,
})

/*************************  Start fetch identity  ************************** */

export const startFetchIdentity = data => ({
    type: UserActionTypes.START_FETCH_IDENTITY,
    payload: data,
})

export const successFetchIdentity = data => ({
    type: UserActionTypes.SUCCESS_FETCH_IDENTITY,
    payload: data,
})

/*************************  Start Get Identity Deposit Limits  ************************** */

export const startGetIdentityDepositLimits = data => ({
    type: UserActionTypes.START_GET_IDENTITY_DEPOSIT_LIMITS,
    payload: data,
})

export const successGetIdentityDepositLimits = data => ({
    type: UserActionTypes.SUCCESS_GET_IDENTITY_DEPOSIT_LIMITS,
    payload: data,
})

export const finishGetIdentityDepositLimits = data => ({
    type: UserActionTypes.FINISH_GET_IDENTITY_DEPOSIT_LIMITS,
    payload: data,
})

export const failureGetIdentityDepositLimits = data => ({
    type: UserActionTypes.FAILURE_GET_IDENTITY_DEPOSIT_LIMITS,
    payload: data,
})

/*************************  Start accept affiliate terms and conditions  ************************** */

export const startAcceptAffiliateTermsAndConditions = data => ({
    type: UserActionTypes.START_ACCEPT_AFFILIATE_TERMS_AND_CONDITIONS,
    payload: data,
})

export const successAcceptAffiliateTermsAndConditions = data => ({
    type: UserActionTypes.SUCCESS_ACCEPT_AFFILIATE_TERMS_AND_CONDITIONS,
    payload: data,
})

export const finishAcceptAffiliateTermsAndConditions = data => ({
    type: UserActionTypes.FINISH_ACCEPT_AFFILIATE_TERMS_AND_CONDITIONS,
    payload: data,
})

/*************************  Start check email availability  ************************** */

export const startCheckEmailAvailability = data => ({
    type: UserActionTypes.START_CHECK_EMAIL_AVAILABILITY,
    payload: data,
})

export const successCheckEmailAvailability = data => ({
    type: UserActionTypes.SUCCESS_CHECK_EMAIL_AVAILABILITY,
    payload: data,
})

export const failureCheckEmailAvailability = data => ({
    type: UserActionTypes.FAILURE_CHECK_EMAIL_AVAILABILITY,
    payload: data,
})

/*************************  Start get identity logged in devices  ************************** */

export const startGetIdentityDevices = data => ({
    type: UserActionTypes.START_GET_IDENTITY_DEVICES,
    payload: data,
})

export const successGetIdentityDevices = data => ({
    type: UserActionTypes.SUCCESS_GET_IDENTITY_DEVICES,
    payload: data,
})

export const finishGetIdentityDevices = data => ({
    type: UserActionTypes.FINISH_GET_IDENTITY_DEVICES,
    payload: data,
})

export const failureGetIdentityDevices = data => ({
    type: UserActionTypes.FAILURE_GET_IDENTITY_DEVICES,
    payload: data,
})

/*************************  Sign out identity from logged in devices  ************************** */

export const startSignOutDevice = data => ({
    type: UserActionTypes.START_SIGN_OUT_DEVICE,
    payload: data,
})

export const successSignOutDevice = data => ({
    type: UserActionTypes.SUCCESS_SIGN_OUT_DEVICE,
    payload: data,
})

export const finishSignOutDevice = data => ({
    type: UserActionTypes.FINISH_SIGN_OUT_DEVICE,
    payload: data,
})

export const failureSignOutDevice = data => ({
    type: UserActionTypes.FAILURE_SIGN_OUT_DEVICE,
    payload: data,
})

export const setSumsubDocumentsSubmitted = (isSubmitted) => ({
    type: UserActionTypes.SET_SUMSUB_DOCUMENTS_SUBMITTED,
    payload: isSubmitted
})
